import { ProductPresenter } from '../presenters';

export const getProductsClusters = (product) => {
  if (!product || !product.cl) return [];

  return ProductPresenter(product).cluster.split('|');
};
